import { useEffect, useState } from "react";
import NocService from "./NocService";
import ApiClient from "../http/ApiClient";
import { Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter } from "react-bootstrap";
import ModalComp from "../common/ModalComp";
import NocForm from "./NocForm";
import ApprovalPage from "./ApprovalPage";
import HistoryNoc from "./HistoryNoc";
import "../style/style.css";

const ApproveNoc = () => {
  const [formValues, setFormValues] = useState({});
  const [nocData, setNocData] = useState([]);
  const [nocFormModalShow, setNocFormModalShow] = useState(false);
  const [applicationId, setApplicationId] = useState({});
  const [nocFormViewShow, setNocFormViewShow] = useState(false);
  const [searchApplicationNumber, setSearchApplicationNumber] = useState('');
  const [searchDepartment, setSearchDepartment] = useState('');

  const nocFormModalShowClose = () => { setNocFormModalShow(false); }
  const nocFormViewShowClose = () => { setNocFormViewShow(false); }

  useEffect(() => {
    getData();
  }, []);

  const departmentMap = {
    "DP1": "CHFW",
    "DP2": "DPHFW",
    "DP3": "TVVP",
    "DP4": "IPMPLFA",
    "DP5": "DACS",
    "DP6": "DCA",
    "DP7": "CAYNUSH",
    "DP8": "YP",
    "DP9": "DFMT",
    "DP10": "DME",
    "DP11": "AHCT",
    "DP12": "TSMMPB",
    "DP13": "TSMSIDC",
    "DP14": "IIHFW",
    "DP15": "NIMS",
    "DP16": "MNJCH",
    "DP17": "MHSRB"
  };

  const getData = () => {
    NocService.pendingNoc().then((result) => {
      setNocData(result);
    })
  };

  const getApplication = (appId) => {
    setApplicationId(appId.refId);
    setNocFormModalShow(true);
  };

  const callBack = (appId) => {
    getData();
    setNocFormViewShow(false);
  };

  const viewApplication = (appId) => {
    setNocFormViewShow(true);
    setApplicationId(appId);
  };

  // Search handler
  const handleSearch = () => {
    NocService.pendingNoc().then((result) => {
      let filteredData = result;

      // Filter by Application Number
      if (searchApplicationNumber) {
        filteredData = filteredData.filter(row =>
          row.nocBean.applicationNumber.toString().includes(searchApplicationNumber)
        );
      }

      // Filter by Department
      if (searchDepartment) {
        filteredData = filteredData.filter(row =>
          departmentMap[row.nocBean.department].toLowerCase().includes(searchDepartment.toLowerCase())
        );
      }

      setNocData(filteredData);
    });
  };

  return (
    <>
      <main id="main" className="main">
        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">NOC Application Worklist</h5>

                  {/* Search Inputs */}
                  <div className="row g-12 mb-4">
                    <div className="col-md-3">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by Application No"
                        value={searchApplicationNumber}
                        onChange={(e) => setSearchApplicationNumber(e.target.value)}
                      />
                    </div>
                    <div className="col-md-3">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by Department"
                        value={searchDepartment}
                        onChange={(e) => setSearchDepartment(e.target.value)}
                      />
                    </div>
                    <div className="col-md-3">
                      <button className="btn btn-primary" onClick={handleSearch}>Search</button>
                    </div>
                  </div>

                  <div className="row g-12">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Application No</th>
                          <th>Name Of Employee</th>
                          <th>Passport No</th>
                          <th>Designation</th>
                          <th>Department</th>
                          <th>View Application</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {nocData && nocData.map((row, index) => (
                          <tr key={index}>
                            <td>{row.nocBean.applicationNumber}</td>
                            <td>{row.nocBean.name}</td>
                            <td>{row.nocBean.passportNumber}</td>
                            <td>{row.nocBean.designation}</td>
                            <td>{departmentMap[row.nocBean.department]}</td>
                            <td>
                              <button
                                type="button"
                                onClick={() => { viewApplication(row) }}
                                className="btn btn-success view-btn"
                              >
                                View
                              </button>
                            </td>
                            <td>
                              <a href="#" onClick={() => { getApplication(row) }}>
                                {row.displayDesc}
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Modals */}
                  <ModalComp
                    size={"lg"}
                    show={nocFormViewShow}
                    handleClose={nocFormViewShowClose}
                    modalTitle={"Proforma particulars to be furnished for Issue of NOC"}
                    modalBody={<NocForm application={applicationId} callBack={callBack} />}
                  />
                  <ModalComp
                    size={"lg"}
                    show={nocFormModalShow}
                    handleClose={nocFormModalShowClose}
                    modalTitle={"History"}
                    modalBody={<HistoryNoc nocId={applicationId} />}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default ApproveNoc;
